/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadedFileResponseDto
 */
export interface UploadedFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    filePath: string;
    /**
     * 
     * @type {number}
     * @memberof UploadedFileResponseDto
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    entityType: UploadedFileResponseDtoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    entityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadedFileResponseDto
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    status?: UploadedFileResponseDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadedFileResponseDto
     */
    isLegacyFile?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileResponseDto
     */
    description?: string;
}


/**
 * @export
 */
export const UploadedFileResponseDtoEntityTypeEnum = {
    Broker: 'broker',
    Claim: 'claim',
    Submission: 'submission',
    SubmissionSov: 'submission_sov',
    Binder: 'binder',
    Reinsured: 'reinsured',
    Insured: 'insured',
    Contract: 'contract',
    ContractAdjustment: 'contract_adjustment',
    ReviewNote: 'review_note',
    Receipt: 'receipt',
    Layer: 'layer'
} as const;
export type UploadedFileResponseDtoEntityTypeEnum = typeof UploadedFileResponseDtoEntityTypeEnum[keyof typeof UploadedFileResponseDtoEntityTypeEnum];

/**
 * @export
 */
export const UploadedFileResponseDtoStatusEnum = {
    Validating: 'Validating',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type UploadedFileResponseDtoStatusEnum = typeof UploadedFileResponseDtoStatusEnum[keyof typeof UploadedFileResponseDtoStatusEnum];


/**
 * Check if a given object implements the UploadedFileResponseDto interface.
 */
export function instanceOfUploadedFileResponseDto(value: object): value is UploadedFileResponseDto {
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UploadedFileResponseDtoFromJSON(json: any): UploadedFileResponseDto {
    return UploadedFileResponseDtoFromJSONTyped(json, false);
}

export function UploadedFileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadedFileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['fileId'],
        'filePath': json['filePath'],
        'fileSize': json['fileSize'],
        'entityType': json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'isActive': json['isActive'],
        'status': json['status'] == null ? undefined : json['status'],
        'isLegacyFile': json['isLegacyFile'] == null ? undefined : json['isLegacyFile'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UploadedFileResponseDtoToJSON(json: any): UploadedFileResponseDto {
    return UploadedFileResponseDtoToJSONTyped(json, false);
}

export function UploadedFileResponseDtoToJSONTyped(value?: UploadedFileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileId': value['fileId'],
        'filePath': value['filePath'],
        'fileSize': value['fileSize'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'isActive': value['isActive'],
        'status': value['status'],
        'isLegacyFile': value['isLegacyFile'],
        'description': value['description'],
    };
}

